import MeaPage from "../../../components/MeaPage";
import { useState } from "react";
import MonthlyCalendar from "./components/MonthlyCalendar";
import CustomAnnualCalendar from "./components/CustomAnnualCalendar";
import { SelectButton } from "primereact/selectbutton";

const PlanningDetailPage = () => {

  // states
  const [view, setView] = useState('annualy');
  // params
  //
  const viewOptions = [

    { label: 'Annuel', value: 'annualy' },
    { label: 'Mensuel', value: 'monthly' },
  ];

  return (
    <>
      <MeaPage
        title="Calendrier"
        subtitle="Aperçu du calendrier de la formation"
        customActions={(
          <div>
            <SelectButton className="p-0" value={view} onChange={(e) => setView(e.value)} options={viewOptions} />
          </div>
        )}

      >
        {view === "monthly" && <MonthlyCalendar />}
        {view === "annualy" && <CustomAnnualCalendar />}
      </MeaPage>
    </>
  );
};
export default PlanningDetailPage;
